import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import errorBoundary from '@ifeng/errorBoundary';

class Menu extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
    };

    state = {
        isOpen: false,
        menuData: [
            { title: '时事', url: 'http://v.ifeng.com/news/#_v_mininav_nav_pc' },
            { title: '军事', url: 'http://v.ifeng.com/mil/#_v_mininav_nav_pc' },
            { title: '人文', url: 'http://v.ifeng.com/humanity/#_v_mininav_nav_pc' },
            { title: '娱乐', url: 'http://v.ifeng.com/ent/#_v_mininav_nav_pc' },
            { title: '搞笑', url: 'http://v.ifeng.com/funny/#_v_mininav_nav_pc' },
            { title: '体育', url: 'http://v.ifeng.com/sports/#_v_mininav_nav_pc' },
            { title: '萌萌哒', url: 'http://v.ifeng.com/cute/#_v_mininav_nav_pc' },
            { title: '看天下', url: 'http://v.ifeng.com/kantianxia/#_v_mininav_nav_pc' },
            { title: '美女', url: 'http://v.ifeng.com/goddess/#_v_mininav_nav_pc' },
            { title: '综艺', url: 'http://v.ifeng.com/variety/#_v_mininav_nav_pc' },
            { title: '科技', url: 'http://v.ifeng.com/keji/#_v_mininav_nav_pc' },
            { title: '旅游', url: 'http://v.ifeng.com/tourism/#_v_mininav_nav_pc' },
            { title: '佛教', url: 'http://v.ifeng.com/fo/#_v_mininav_nav_pc' },
            { title: '涨知识', url: 'http://v.ifeng.com/knowledge/#_v_mininav_nav_pc' },
            {
                title: '更多',
                url: '',
                children: [
                    { title: '视频首页', url: 'http://v.ifeng.com/#_v_mininav_nav_pc' },
                    { title: '凤凰首页', url: 'http://www.ifeng.com/#_v_mininav_nav_pc' },
                    { title: 'APP下载', url: 'http://v.ifeng.com/apps/index.shtml#_v_mininav_nav_pc' },
                ],
            },
        ],
    };

    handleMouseEnter = () => {
        this.setState({
            isOpen: true,
        });
    };
    handleMouseLeave = () => {
        this.setState({
            isOpen: false,
        });
    };

    render() {
        const { isOpen, menuData } = this.state;
        const { content } = this.props;

        let foldData = '';
        const nav = (
            <ul className={`${styles.listBox} clearfix`}>
                {content.map((item, index) => {
                    if (item.title === '更多') {
                        foldData = item.children;

                        return null;
                    } else {
                        return (
                            <li key={index}>
                                <a href={item.url} target="_blank">
                                    {item.title}
                                </a>
                            </li>
                        );
                    }
                })}
            </ul>
        );
        const fold = (
            <div className={styles.vlbackhome}>
                {foldData.map((item, index) => {
                    return (
                        <a href={item.url} target="_blank" key={index}>
                            {item.title}
                        </a>
                    );
                })}
            </div>
        );

        return (
            <div className={styles.vMenu} onMouseEnter={this.handleMouseEnter} onMouseLeave={this.handleMouseLeave}>
                <div className={styles.vSelect} title="选频道">
                    选频道
                </div>
                <div style={{ display: isOpen ? 'block' : 'none' }} className={styles.vMenuBox}>
                    {nav}
                    {fold}
                </div>
            </div>
        );
    }
}

export default errorBoundary(Menu);
